import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UpgradeModule } from '@angular/upgrade/static'
import { UrlHandlingStrategy, UrlTree } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from './environments/environment';
import { EmptyComponent } from './components/empty/empty.component';
import { WingsJsComponent } from './components/wingsJs/wings-js.component';
import { WingsAssistantChatModule } from './components/wings-assistant-chat/wings-assistant-chat.module';
import { BootstrapingService } from './services/bootstraping.service';
import { WingsAssistantChatService } from './components/services/wings-assistant-chat.service';
import { ChatTranslationService } from './components/services/chat-translation.service';
import { MarkdownModule } from 'ngx-markdown';
import {
  MsalModule,
  MsalInterceptor,
  MsalGuard,
  MsalService,
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  IPublicClientApplication
} from '@azure/msal-browser';

class HybridUrlHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url: UrlTree) { 
    return url.toString().startsWith("/access_token") || url.toString() == "/" || url.toString().endsWith("/WingsAngular");
  }
  extract(url: UrlTree) { return url; }
  merge(url: UrlTree, whole: UrlTree) { return url; }
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: environment.msalConfig.auth.redirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.apiConfig.scopes
    }
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [environment.apiConfig.uri, environment.apiConfig.scopes],
      [environment.chatAgentUrl, environment.apiConfig.scopes]
    ])
  };
}

@NgModule({
  declarations: [
    AppComponent,
    WingsJsComponent,
    EmptyComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    UpgradeModule,
    HttpClientModule,
    MarkdownModule.forRoot(),
    WingsAssistantChatModule,
    FormsModule,
    MsalModule
  ],
  providers: [
    { provide: UrlHandlingStrategy, useClass: HybridUrlHandlingStrategy },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    BootstrapingService,
    WingsAssistantChatService,
    ChatTranslationService  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  
}
